export default "__VITE_ASSET__Dhv7AEiK__"